module.exports = __webpack_public_path__ + "static/media/logo.715b6fd7.svg";